// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import './App.css';
// import Dashboard from './Pages/Dashboard';
// import SignIn from './Pages/SignIn';
// import Registration from './Pages/Registration';
// import ProtectedRoute from './ProtectedRoute';
// import SignIn1 from './Pages/SIgnIn1';
// import Home from './Pages/Home/Home';

// function App() {
//   return (
//     <Router>
//       <div className="App">
//         <Routes>
//           {/* Public routes */}
//           <Route path="/signin" element={<SignIn />} />
//            <Route path="/" element={<Home />} />
//           <Route path="/register" element={<Registration />} />
          
//           {/* Protected Dashboard */}
//           <Route 
//             path="/dashboard" 
//             element={
//               // <ProtectedRoute>
//                 <Dashboard />
//               // </ProtectedRoute>
//             } 
//           />
          
        
//         </Routes>
//       </div>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { Routes, Route } from 'react-router-dom';
// import './App.css';
// import Dashboard from './Pages/Dashboard';
// import SignIn from './Pages/SignIn';
// import Registration from './Pages/Registration';
// import Home from './Pages/Home/Home';

// function App() {
//   return (
//     <div className="App">
//       <Routes>
//         {/* Public routes */}
//         <Route path="/signin" element={<SignIn />} />
//         <Route path="/" element={<Home />} />
//         <Route path="/register" element={<Registration />} />

//         {/* Protected Dashboard */}
//         <Route
//           path="/dashboard"
//           element={<Dashboard />}
//         />
//       </Routes>
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Dashboard from './Pages/Dashboard';
import SignIn from './Pages/SignIn';
import Registration from './Pages/Registration';
import Home from './Pages/Home/Home';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import PaymentReport from './Pages/Dashboard/PaymentReport';
import Demo from './Pages/Demo';
import WalletTransfer from './Pages/Dashboard/WalletTransfer';
import WalletTransaction from './Pages/Dashboard/WalletTransaction';
import ChangePassword from './Pages/Dashboard/ChangePassword';
import GenealogyTree from './Pages/Dashboard/GenealogyTree';
import GenealogyLeadTree from './Pages/Dashboard/GenealogyLeadTree';
import LevelIncome from './Pages/Dashboard/LevelIncome';
import TeamIncome from './Pages/Dashboard/TeamIncome';
import SeniorReTopUp from './Pages/Dashboard/SeniorReTopUp';
import CMDBonus from './Pages/Dashboard/CMDBonus';
import MaxDirects from './Pages/Dashboard/MaxDirects';
import MaxIncome from './Pages/Dashboard/MaxIncome';
import LowestIncome from './Pages/Dashboard/LowestIncome';
import ZeroIncome from './Pages/Dashboard/ZeroIncome';
import ROIOverview from './Pages/Dashboard/ROIOverview';
import UpgradePlan from './Pages/Dashboard/UpgradePlan';
import FuelDeposit from './Pages/Dashboard/FuelDeposit';
import PlanUpgradeReport from './Pages/Dashboard/PlanUpgradeReport';
import AddBond from './Pages/Dashboard/AddBond';
import UnusedBond from './Pages/Dashboard/UnusedBond';
import RegistrationPayment from './Pages/Dashboard/RegistrationPayment';
import UsedBond from './Pages/Dashboard/UsedBond';
import PaymentVerification from './Pages/Dashboard/PaymentVerification';
import RegisterPaymentList from './Pages/Dashboard/RegisterPaymentList';
import AdminLogin from './Pages/Dashboard/Admin/AdminLogin';
import BinaryIncome from './Pages/Dashboard/BinaryIncome';
import Genealogicaltree from './Pages/Dashboard/Genealogicaltree';


// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state) => state.user);
  
  // Check if token exists and is valid
  const isTokenValid = () => {
    if (!token) return false;
    
    try {
      // Decode token to check expiry
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      
      // Check if token is expired
      if (decodedToken.exp < currentTime) {
        console.log('Token expired');
        return false;
      }
      
      return true;
    } catch (error) {
      console.log('Invalid token:', error);
      return false;
    }
  };

  // Check both Redux state and localStorage for backward compatibility
  const hasValidToken = () => {
    // Check Redux state first
    if (isAuthenticated && token && isTokenValid()) {
      return true;
    }
    
    // Check localStorage as fallback
    const localToken = localStorage.getItem('willowToken');
    if (localToken) {
      try {
        const decodedToken = jwtDecode(localToken);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp >= currentTime) {
          return true;
        } else {
          // Remove expired token
          localStorage.removeItem('willowToken');
          localStorage.removeItem('willowUser');
        }
      } catch (error) {
        console.log('Invalid local token:', error);
        localStorage.removeItem('willowToken');
        localStorage.removeItem('willowUser');
      }
    }
    
    return false;
  };

  if (!hasValidToken()) {
    // Redirect to login if no valid token
    return <Navigate to="/signin" replace />;
  }

  return children;
};

// Public Route Component (redirects to dashboard if already logged in)
// const PublicRoute = ({ children }) => {
//   const { token, isAuthenticated } = useSelector((state) => state.user);
  
//   const isTokenValid = () => {
//     if (!token) return false;
    
//     try {
//       const decodedToken = jwtDecode(token);
//       const currentTime = Date.now() / 1000;
      
//       if (decodedToken.exp < currentTime) {
//         return false;
//       }
      
//       return true;
//     } catch (error) {
//       return false;
//     }
//   };

//   const hasValidToken = () => {
//     if (isAuthenticated && token && isTokenValid()) {
//       return true;
//     }
    
//     const localToken = localStorage.getItem('willowToken');
//     if (localToken) {
//       try {
//         const decodedToken = jwtDecode(localToken);
//         const currentTime = Date.now() / 1000;
        
//         if (decodedToken.exp >= currentTime) {
//           return true;
//         }
//       } catch (error) {
//         return false;
//       }
//     }
    
//     return false;
//   };

//   if (hasValidToken()) {
//     // Redirect to dashboard if already authenticated
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children;
// };

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public routes - only accessible when NOT logged in */}
        <Route path="/signin" element={
       
            <SignIn />
         
        } />
         <Route path="/admin/signin" element={<AdminLogin />} />
         <Route path="/demo" element={
          // <PublicRoute>
            <Demo />
          // </PublicRoute>
        } />
        
        <Route path="/" element={<Home />} />
         <Route path="/GenealogyTree" element={<GenealogyTree />} />
        
        <Route path="/register" element={
          // <PublicRoute>
            <Registration />
          // </PublicRoute>
        } />

        {/* Protected Dashboard - only accessible with valid token */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
  path="/wallet-transfer"
  element={
    <ProtectedRoute>
      <WalletTransfer />
    </ProtectedRoute>
  }
/>

        <Route
  path="/wallet-transaction"
  element={
    <ProtectedRoute>
      <WalletTransaction />
    </ProtectedRoute>
  }
/>
         <Route
          path="/payment-report"
          element={
            <ProtectedRoute>
              <PaymentReport/>
            </ProtectedRoute>
          }
        />

      
<Route
  path="/change-password"
  element={
    <ProtectedRoute>
      <ChangePassword />
    </ProtectedRoute>
  }
/>

  <Route path="/dashboard" element={<Dashboard />} />
  {/* <Route path="/ecosystem/working" element={<ComingSoon title="Working / Community Ecosystem" />} />
  <Route path="/ecosystem/roi-qi" element={<ComingSoon title="ROI / QI Ecosystem" />} />
  <Route path="/ecosystem/gaming" element={<ComingSoon title="Gaming Ecosystem" />} />
  <Route path="/ecosystem/token" element={<ComingSoon title="Token / Payment Ecosystem" />} /> */}

{/* Registration & Team */}
        {/* <Route path="/registration/new-joining" element={<ProtectedRoute><NewJoining /></ProtectedRoute>} />
        <Route path="/registration/crowd-signups" element={<ProtectedRoute><CrowdSignups /></ProtectedRoute>} /> */}
        <Route path="/registration/direct-leads" element={<ProtectedRoute><GenealogyLeadTree /></ProtectedRoute>} />
       <Route path="/registration/team-network" element={<ProtectedRoute><GenealogyTree /></ProtectedRoute>} />

      
         <Route path="/income/level-income" element={<ProtectedRoute><LevelIncome /></ProtectedRoute>} />
       <Route path="/income/team-income" element={<ProtectedRoute><TeamIncome /></ProtectedRoute>} />
       <Route path="/income/binary-income" element={<ProtectedRoute><BinaryIncome /></ProtectedRoute>} />
        <Route path="/income/senior-retopup-income" element={<ProtectedRoute><SeniorReTopUp /></ProtectedRoute>} />
        <Route path="/income/cmd-bonus" element={<ProtectedRoute><CMDBonus /></ProtectedRoute>} />
        <Route path="/income/24-max-directs" element={<ProtectedRoute><MaxDirects /></ProtectedRoute>} />
        <Route path="/income/24-max-income" element={<ProtectedRoute><MaxIncome /></ProtectedRoute>} />
        <Route path="/income/24-lowest-income" element={<ProtectedRoute><LowestIncome /></ProtectedRoute>} />
        <Route path="/income/24-zero-income" element={<ProtectedRoute><ZeroIncome /></ProtectedRoute>} />
        <Route path="/income/roi-overview" element={<ProtectedRoute><ROIOverview /></ProtectedRoute>} /> 

         <Route path="/bond/add-bond" element={<ProtectedRoute><AddBond /></ProtectedRoute>} />
       <Route path="/bond/unused-bond" element={<ProtectedRoute><UnusedBond /></ProtectedRoute>} />
       <Route path="/bond/used-bond" element={<ProtectedRoute><UsedBond /></ProtectedRoute>} />
       
         <Route path="/fund-management/fuel-deposit" element={<ProtectedRoute><FuelDeposit /></ProtectedRoute>} /> 
         <Route path="/plan-upgrade-report" element={<ProtectedRoute><PlanUpgradeReport /></ProtectedRoute>} /> 

<Route path="/upgrade-plan" element={<UpgradePlan />} />

<Route path="/registration-payment" element={<RegistrationPayment />} />

<Route path="/registration/Genealogicaltree" element={<Genealogicaltree />} />

{/* <Route path="/check/payment/:id" element={<PaymentVerification />} /> */}

<Route 
  path="/payment/:id" 
  element={
    <ProtectedRoute>
      <RegisterPaymentList />
    </ProtectedRoute>
  } 
/>

        {/* Catch all route - redirect to home or login */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
      </Routes>
    </div>
  );
}

export default App;